export const FCM_TOKEN_KEY = "raychat_web_app_fcm_token";
